export const LOADING_TEXT = "Loading...";
export const NOT_IN_IFRAME = "Please run app in iframe";
export const FAILED_INIT = "Maintenance";
export const UNAUTHORIZED = "Unauthorized";
